<div class="desktop" *ngIf="isMobile === false  && isTablet === false">
  <router-outlet></router-outlet>
</div>
<div *ngIf="isMobile === true  || isTablet === true">
  <router-outlet></router-outlet>
</div>

<div class="desktop-cookies col-3" *ngIf="mostrarCookies && !masInfo && isMobile === false  && isTablet === false && cookies === null">
  <div class="column">
    <img src="assets/images/fad_logo_black.png" alt="">
  </div>
  <div class="column">
    <p class="title">
      FAD ® y las cookies...  
    </p>
    <p class="description">
      Este sitio utiliza cookies. Al hacer clic en ACEPTAR o al continuar navegando en el sitio estás aceptando nuestro uso de cookies.
    </p>
  </div>
  <div class="column">
    <div id="pop_terminos_aceptar" (click)="aceptarCookies()" class="button">
      ACEPTAR
    </div>
    <br>
    <p class="enlace" (click)="masInfo = true">Más información...</p>
  </div>
</div>
<div class="desktop-cookies" *ngIf="mostrarCookies && masInfo && isMobile === false  && isTablet === false && cookies === null">
  <div class="column column-3">
    <p class="title" style="cursor: pointer;  display:inline-block;" (click)="masInfo = false; mostrarCookies = true">
      < Regresar
    </p>
    <p class="description">
      Le informamos que Usted al ingresar en nuestro sitio web recabamos cookies, las cookies son unos archivos de texto pequeños encriptados que se encuentran dentro de su navegador, en nuestro sitio web ayudan al usuario realizar ciertas funciones como el método de búsqueda o inicio de sesión, recordando el usuario y contraseña dentro de su navegador, recordar los productos en el carrito de compras, recomendarle productos o servicios de acuerdo a su perfil; las cookies facilitan este proceso de manera rápida y eficiente.
    </p>
    <div class="container">
      <p class="title">
        Las cookies que utilizamos son las siguientes:
      </p>
      <p class="description">
        De entrada del usuario, de identificación, de seguridad del usuario, de sesión para equilibrar la carga, de complemento (plug-in),de  propiedad, de sesión, de análisis, publicitarias.
        <b>Usted puede activar y desactivar las cookies desde su navegador.</b>
      </p>
    </div>
    <div id="pop_terminos_aceptar_info" (click)="aceptarCookies()" class="button complete">
      ACEPTAR
    </div>
  </div>
</div>

<!-- FASIVO MOVIL -->

<div class="movil-cookies row-3" *ngIf="mostrarCookies && !masInfo && ( isMobile === true  || isTablet === true ) && cookies === null">
  <div class="column">
    <img src="assets/images/fad_logo_black.png" alt="">
  </div>
  <div class="column">
    <p class="title">
      FAD ® y las cookies...
    </p>
    <p class="description">
      Este sitio utiliza cookies. Al hacer clic en ACEPTAR o al continuar navegando en el sitio estás aceptando nuestro uso de cookies.
    </p>
  </div>
  <div class="column">
    <div id="pop_terminos_aceptar_movil" (click)="aceptarCookies()" class="button">
      ACEPTAR
    </div>
    <br>
    <p class="enlace" (click)="masInfo = true">Más información...</p>
  </div>
</div>

<div class="movil-cookies" *ngIf="mostrarCookies && masInfo && ( isMobile === true  || isTablet === true ) && cookies === null">
  <div class="column column-3">
    <p class="title" style="cursor: pointer;  display:inline-block;" (click)="masInfo = false; mostrarCookies = true">
      < Regresar
    </p>
    <p class="description">
      Le informamos que Usted al ingresar en nuestro sitio web recabamos cookies, las cookies son unos archivos de texto pequeños encriptados que se encuentran dentro de su navegador, en nuestro sitio web ayudan al usuario realizar ciertas funciones como el método de búsqueda o inicio de sesión, recordando el usuario y contraseña dentro de su navegador, recordar los productos en el carrito de compras, recomendarle productos o servicios de acuerdo a su perfil; las cookies facilitan este proceso de manera rápida y eficiente.
    </p>
    <div class="container">
      <p class="title">
        Las cookies que utilizamos son las siguientes:
      </p>
      <p class="description">
        De entrada del usuario, de identificación, de seguridad del usuario, de sesión para equilibrar la carga, de complemento (plug-in),de  propiedad, de sesión, de análisis, publicitarias.
        <b>Usted puede activar y desactivar las cookies desde su navegador.</b>
      </p>
    </div>
    <div id="pop_terminos_aceptar_info_movil" (click)="aceptarCookies()" class="button complete">
      ACEPTAR
    </div>
  </div>
</div>

<div  *ngIf="loading">
  <div class="loader">
    <img class="" src="assets/images/loader_FAD.gif" alt="">
  </div>
</div>
